<template>
    <div class="app-footer-component">
        <div class="app-footer-component-wrapper">
            <div class="btns-container">
                <div class="btn-container" :class="{ active: $store.activeNavBarButton === 'home' }" @click="displayHomePageHandle">
                    <div class="btn-wrapper">
                        <img class="home-icon" src="../../assets/icons/home.png" alt="home_icon">
                    </div>
                </div>
                <!-- <div class="btn-container" :class="{ active: $store.activeNavBarButton === 'search' }" @click="showHomePageSearchBarHandle">
                    <div class="btn-wrapper">
                        <img class="search-icon" src="../../assets/icons/search.png" alt="search_icon">
                    </div>
                </div> -->
                <div class="btn-container" :class="{ active: $store.activeNavBarButton === 'settings' }" @click="displayUserSettingsPageHandle">
                    <div class="btn-wrapper">
                        <img class="user-icon" src="../../assets/icons/user.png" alt="user_icon">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppFooter',
    data() {
        return {
        }
    },
    methods: {
        displayUserSettingsPageHandle: function() {
            this.$store.activeNavBarButton = 'settings';
            this.$router.push('/settings');
        },
        displayHomePageHandle: function() {
            this.$store.activeNavBarButton = 'home';
            this.$router.push('/home');
        },
        // showHomePageSearchBarHandle: function() {
        //     const currentUrl = window.location.href;
        //     if (currentUrl.includes('home') && !this.$store.showStudiosOptionsPage) {
        //         this.$store.activeNavBarButton = 'search';
        //         this.$store.showHomePageSearchBar = true;
        //     }
        // },
        // toggleSearchBar() {
        //     console.log("Change search bar status...");
        //     this.$emit('toggleSearchBar');
        // }
    },
}
</script>

<style>
.app-footer-component {
    /* position: fixed;
    bottom: 0; */
    height: 65px;
    width: 100%;
    max-width: 1500px;
    /* z-index: 999; */
    background: #ffffff;
    border-top: 2px solid #E6E6E6;
    box-shadow: 0 0 5px 0 #E6E6E6;
    /* border: 1px solid red; */
}

.app-footer-component .app-footer-component-wrapper {
    height: 100%;
    width: 100%;
}

.app-footer-component .btns-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    padding: 0 5%;
}

.app-footer-component .btn-container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

/* .btn-container:hover {
    filter: brightness(0) saturate(100%) invert(47%) sepia(96%) saturate(2597%) hue-rotate(174deg) brightness(97%) contrast(105%);
} */

.app-footer-component .active {
    filter: brightness(0) saturate(100%) invert(47%) sepia(96%) saturate(2597%) hue-rotate(174deg) brightness(97%) contrast(105%);
}

.app-footer-component .btn-wrapper {
    height: 65%;
}

.app-footer-component .btn-wrapper img {
    height: 100%;
}

.app-footer-component .search-icon {
    padding: 3px;
}

.app-footer-component .user-icon {
    padding: 1px;
}


</style>